import Phaser from "phaser";
import gameConfig from "./game/gameConfig";
import { enableAllPlugins } from "immer";
import { App } from "./devUI/main";
import React from "react";
import ReactDOM from "react-dom";
import { getDevEmitter } from "./devUI/devEvents";

import "../node_modules/toastr/build/toastr.css";
import { DEV_MODE } from "./game/constants";

// Required for itch.io to focus on the canvas after loading.
window.addEventListener(
  "mousedown",
  function (evt) {
    window.focus();
    evt.preventDefault();
    evt.stopPropagation();
    evt.target.style.cursor = "default";
  },
  false
);

// Allow use of patches for immer.
enableAllPlugins();
if (DEV_MODE) {
  ReactDOM.render(<App />, document.body);
}

function newGame() {
  if (game) return;
  game = new Phaser.Game(gameConfig);
}

function destroyGame() {
  if (!game) return;

  if (getDevEmitter()) {
    getDevEmitter().removeAllListeners();
  }

  game.destroy(true);
  game.runDestroy();
  game = null;
}

var game;

if (module.hot) {
  module.hot.dispose(destroyGame);
  module.hot.accept(newGame);
}

if (!game) newGame();
